import State from "ducks/state"
import {connect} from "react-redux"
import {breakpoints} from "@next/ux-fabric"
import {getUpperHeaderHeight} from "../../../../utils/getHeaderHeight"
import {shouldDisplayBackToSiteBanner} from "../../../../utils/backToSiteBanner"
import {ENTRYPOINT_HEADER_NAME} from "../../../../config/constants"
import {SupportedRegionTypes} from "../../../../models/regions"
import checkBannerVisibility from "../../../../utils/checkBannerVisibility"

export const mapStateToProps = (state: State) => {
    const {
        settings: {
            template,
            showStaticHeaderBanner,
            enableContentBanner,
            isCountrySelectorInGlobalAppBar,
            backToNextBannerShowAlways,
        },
        autocomplete: {numFound, suggestions, isLoading},
    } = state

    const messageBannerControls: any = state.data?.regions.find(
        region => region.type === SupportedRegionTypes.MessageBanner,
    )

    const showBackToSiteBanner = shouldDisplayBackToSiteBanner(
        state.data?.regions,
        state.settings.backToSiteBannerConfiguration,
        state.request.headers?.[ENTRYPOINT_HEADER_NAME],
        backToNextBannerShowAlways,
    )
    const isNoResults = !isLoading && suggestions?.length === 0 && numFound === 0
    const bannerVisibility = checkBannerVisibility(
        state.data?.regions.find(region => region.type === SupportedRegionTypes.StaticBannerLinks)?.elements,
        enableContentBanner,
        state.request.url,
        messageBannerControls?.enabled,
        showStaticHeaderBanner,
        (typeof window !== "undefined" && window.innerWidth > breakpoints.values.md) || true, // Default to true for SSR
        isCountrySelectorInGlobalAppBar,
    )
    const headerHeights = getUpperHeaderHeight(
        template,
        bannerVisibility.showaAppBar,
        bannerVisibility.showCMSBanner,
        showBackToSiteBanner,
    )

    return {
        desktopHeight: headerHeights.desktop,
        isNoResults,
    }
}

export default connect(mapStateToProps)
